<div class="login-page">
  <main class="login-main">
    <div class="login-wrap">
      <div class="login-hero">
        <button type="button" class="login-mascot login-mascot--link" (click)="goLogin()" aria-label="Torna al login">
          <img src="assets/images/walley-bot.png" alt="" />
        </button>
        <p class="login-tagline">{{ 'LOGIN.ENT_TAGLINE' | translate }}</p>
      </div>

      <div class="login-card glass-card auth-card" appInViewport>
        <app-back-button class="auth-back-btn" (back)="goLogin()" ariaLabel="Torna al login"></app-back-button>
        <div class="auth-flow-body">
          <h2 class="auth-flow-title">{{ 'RECOVER-PASSWORD.TITLE' | translate }}</h2>
          <p class="auth-flow-subtitle">{{ 'RECOVER-PASSWORD.SUBTITLE' | translate }}</p>
          <form [formGroup]="recoverPswForm" (submit)="$event.preventDefault()" class="login-form">
            <div class="login-field">
              <label class="login-label" for="email">{{ 'LOGIN.EMAIL_CORP' | translate }}</label>
              <div class="login-input-wrap">
                <i class="bi bi-envelope login-input-icon" aria-hidden="true"></i>
                <input
                  type="email"
                  name="email"
                  id="email"
                  formControlName="email"
                  class="login-input"
                  [class.login-input--invalid]="!validEmail"
                  [placeholder]="'LOGIN.PLACEHOLDER_EMAIL' | translate"
                  autocomplete="email"
                  aria-describedby="emailFeedback"
                />
              </div>
              @if (!validEmail) {
                <div id="emailFeedback" class="login-field-error" role="alert">
                  <small>{{ 'RECOVER-PASSWORD.MSG_ERRORS' | translate }}</small>
                </div>
              }
            </div>
            <button type="button" class="login-submit" (click)="send()">
              <span>{{ 'RECOVER-PASSWORD.BUTTON_SEND' | translate }}</span>
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>
          </form>
        </div>
      </div>

      <div class="login-trust">
        <i class="bi bi-shield-check" aria-hidden="true"></i>
        <p>Walley - ERP</p>
      </div>
    </div>
  </main>
</div>
